import React from 'react';
import { Router, Route } from 'react-router';

import App from './components/App';
import About from './components/About';
import Projects from './components/Projects';
import AngelList from './components/Projects/AngelList';
import AngelListSource from './components/Projects/AngelList/Source';
import AngelListTalent from './components/Projects/AngelList/Talent';
import PetsChamp from './components/Projects/PetsChamp';
import Quora from './components/Projects/Quora';
import QuoraGrowth from './components/Projects/Quora/Growth';
import QuoraNotifications from './components/Projects/Quora/Notifications';
import QuoraQuality from './components/Projects/Quora/Quality';
import Rainmakers from './components/Projects/Rainmakers';
import Resume from './resume.pdf';
import sgBEAT from './components/Projects/sgBEAT';
import Surveylicious from './components/Projects/Surveylicious';
import Tutorific from './components/Projects/Tutorific';
import NotFound from './components/NotFound';

const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={App} />
    <Route path="/about" component={About} />
    <Route path="/projects" component={Projects} />
    <Route path="/projects/angellist" component={AngelList} />
    <Route path="/projects/angellist/source" component={AngelListSource} />
    <Route path="/projects/angellist/talent" component={AngelListTalent} />
    <Route path="/projects/petschamp" component={PetsChamp} />
    <Route path="/projects/quora" component={Quora} />
    <Route path="/projects/quora/growth" component={QuoraGrowth} />
    <Route path="/projects/quora/notifications" component={QuoraNotifications} />
    <Route path="/projects/quora/quality" component={QuoraQuality} />
    <Route path="/projects/rainmakers" component={Rainmakers} />
    <Route path="/projects/sgbeat" component={sgBEAT} />
    <Route path="/projects/surveylicious" component={Surveylicious} />
    <Route path="/projects/tutorific" component={Tutorific} />
    <Route path="/resume" component={Resume} />
    <Route path="*" component={NotFound} />
  </Router>
);

export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js